
import {
  computed,
  defineComponent,
  reactive,
  watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useGradeBase } from '@/core/composables/GradeBase';
import SelecionarControleProducao from './SelecionarControleProducao.vue';
import { IEngenhariaControle } from '@/models/Entidades/Cadastros/PCP/IEngenhariaProduto';
import { IControleProducao } from '@/models/Entidades/Cadastros/PCP/IControleProducao';
import ServicoContloleProducao from '@/servicos/Cadastros/PCP/ServicoControleProducao';

export default defineComponent({
  name: 'EngenhariaControle',
  props: {
    visivel: {
      type: Boolean,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    controles: {
      type: Array as () => IEngenhariaControle[],
      required: true,
    },
    codigoEngenharia: {
      type: Number,
      required: true,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icone,
    SelecionarControleProducao,
  },
  emits: ['salvar', 'update:visivel', 'update:controle'],
  setup(props, { emit }) {
    const {
      apresentarMensagemAlerta,
    } = useTelaBase();
    const {
      gradeBase,
    } = useGradeBase();
    const servicoContloleProducao = new ServicoContloleProducao();
    const state = reactive({
      editavel: true,
      codigoProdutoSelecionado: -1,
      descricaoSelecionado: '',
      codigo: 0,
      controle: {} as IControleProducao,
      incluirNaObservacao: false,
      utilizarParaCalculoComponente: false,
    });

    const computedControle = computed({
      get: () => props.controles,
      set: (val: IEngenhariaControle[]) => {
        emit('update:controle', val);
      },
    });

    function objetoInicial() {
      state.editavel = true;
      state.codigoProdutoSelecionado = -1;
      state.codigo = 0;
      state.descricaoSelecionado = '';
      state.incluirNaObservacao = false;
      state.utilizarParaCalculoComponente = false;
      state.controle = {} as IControleProducao;
    }

    function limparCampos() {
      state.codigoProdutoSelecionado = -1;
      state.codigo = 0;
      state.descricaoSelecionado = '';
      state.incluirNaObservacao = false;
      state.utilizarParaCalculoComponente = false;
      state.controle = {} as IControleProducao;
    }

    function validaCampos() {
      if (!UtilitarioGeral.validaCodigo(state.codigo)) {
        apresentarMensagemAlerta('Por favor selecione um controle!');
        return false;
      }
      if (state.codigoProdutoSelecionado === -1 && computedControle.value.some((p) => p.codigoControleProducao === state.codigo)) {
        apresentarMensagemAlerta('O controle já foi adicionado!');
        return false;
      }
      if (state.codigoProdutoSelecionado === -1 && computedControle.value.some((p) => p.tipoControle === state.controle.tipoControle && state.controle.tipoControle > 1)) {
        apresentarMensagemAlerta('Já existe um controle desse tipo informado!');
        return false;
      }
      return true;
    }

    async function adicionar() {
      if (!validaCampos()) { return; }
      if (state.codigoProdutoSelecionado !== -1) {
        computedControle.value[state.codigoProdutoSelecionado].codigoControleProducao = state.codigo;
        computedControle.value[state.codigoProdutoSelecionado].descricao = state.descricaoSelecionado;
        computedControle.value[state.codigoProdutoSelecionado].tipoControle = state.controle.tipoControle;
        limparCampos();
      } else {
        const controle: IEngenhariaControle = {} as IEngenhariaControle;
        controle.codigoEngenharia = props.codigoEngenharia;
        controle.codigoControleProducao = state.codigo;
        controle.descricao = state.descricaoSelecionado;
        controle.tipoControle = state.controle.tipoControle;
        computedControle.value.push(controle);
        limparCampos();
      }
    }

    function excluir(index: number) {
      computedControle.value.splice(index, 1);
      state.codigoProdutoSelecionado = -1;
    }

    function editar(index: number) {
      state.codigoProdutoSelecionado = index;
    }

    // Sincroniza campos ao editar
    watch(() => state.codigoProdutoSelecionado, async (newValue) => {
      if (newValue !== -1) {
        const item = computedControle.value[newValue];
        state.codigo = item.codigoControleProducao;
        state.descricaoSelecionado = item.descricao;
        state.controle.tipoControle = item.tipoControle;
      } else {
        limparCampos();
      }
    });
    watch(() => state.codigo, async (newValue) => {
      if (!newValue) {
        objetoInicial();
      } else {
        state.controle = await servicoContloleProducao.obter(state.codigo, props.empresas[0]);
      }
    });
    return {
      props,
      state,
      objetoInicial,
      EPermissaoDados,
      gradeBase,
      editar,
      excluir,
      adicionar,
      computedControle,
      UtilitarioGeral,
    };
  },
});
